import axios from 'axios';
import bcryptjs from 'bcryptjs';
import { BASE_URL, XC_TOKEN, TABLES } from './apiConstants';

const SALT_ROUNDS = 10; // Standard salt rounds for bcrypt

const authApi = {
  signIn: async (credentials) => {
    try {
      const response = await axios.get(`${BASE_URL}/tables/${TABLES.AUTH}/records`, {
        headers: {
          accept: 'application/json',
          'xc-token': XC_TOKEN,
        },
        params: {
          where: `(Email,eq,${credentials.email})`,
          limit: 1,
        },
      });

      // If user exists, verify password with bcrypt
      if (response.data.list.length > 0) {
        const user = response.data.list[0];
        const passwordMatch = await bcryptjs.compare(credentials.password, user.Password);
        
        // If password doesn't match, throw error
        if (!passwordMatch) {
          throw new Error('Invalid password');
        }
      }

      return response;
    } catch (error) {
      console.error('SignIn Error:', error);
      throw error;
    }
  },

  signUp: async (userData) => {
    try {
      const checkResponse = await axios.get(`${BASE_URL}/tables/${TABLES.AUTH}/records`, {
        headers: { 'xc-token': XC_TOKEN },
        params: { where: `(Email,eq,${userData.Email})`, limit: 1 },
      });

      if (checkResponse.data.list.length > 0) {
        throw new Error('Email already exists');
      }

      // Hash the password before storing
      const hashedPassword = await bcryptjs.hash(userData.Password, SALT_ROUNDS);

      const response = await axios.post(
        `${BASE_URL}/tables/${TABLES.AUTH}/records`,
        {
          Email: userData.Email,
          Password: hashedPassword, // Store the hashed password
        },
        {
          headers: {
            accept: 'application/json',
            'xc-token': XC_TOKEN,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        throw new Error('Email already exists');
      }
      console.error('SignUp Error:', error);
      throw error;
    }
  },

  signOut: async () => {
    return Promise.resolve();
  },
};

export default authApi;